import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Swim = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="swim"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.92224 8.17141L9.24452 8.85563C9.43026 9.32726 10.3662 11.6487 10.5421 12.0641C10.5421 12.0641 10.5421 12.0641 10.5397 12.0641C8.99771 12.8266 7.45576 13.5865 5.91382 14.349C6.44898 14.2512 6.99147 14.2023 7.5364 14.2023C8.24995 14.2023 8.94884 14.2879 9.61595 14.4565C10.9624 14.7986 12.1793 15.346 13.3547 15.8762C14.4031 16.3479 15.3952 16.7951 16.3849 17.0517C16.5242 17.0883 16.6586 17.1201 16.793 17.1469C15.62 14.7448 12.4653 8.2716 11.8421 6.84695C11.5489 6.17495 11.1457 5.92569 10.5739 5.85239L4.32302 5.04842C3.46041 4.93846 2.67111 5.54693 2.5587 6.40954C2.45116 7.27215 3.05963 8.06145 3.92224 8.17141Z" />
      <path d="M1.40747 20.3975C1.58096 20.5222 1.7789 20.5808 1.97684 20.5808C2.02082 20.5808 2.06236 20.5783 2.10391 20.571C2.36293 20.5368 2.6073 20.4 2.77102 20.1727C3.40393 19.2905 4.38383 18.5966 5.52502 18.2153C6.17992 17.9979 6.86414 17.8879 7.53615 17.8879C9.97247 17.8879 12.0618 19.3443 14.2611 20.1825C15.4389 20.6321 16.6681 20.9644 18.0047 20.9644C18.5668 20.9644 19.1484 20.9058 19.7519 20.7714C21.1717 20.4586 22.3886 19.7842 23.2684 18.8385C23.4785 18.6112 23.6691 18.3717 23.8377 18.1151C24.1359 17.6655 24.0112 17.0595 23.5616 16.7614C23.3954 16.6514 23.2097 16.6001 23.024 16.6001C22.7063 16.6001 22.396 16.754 22.2078 17.0375C22.1321 17.1523 22.049 17.2623 21.9586 17.3698C21.3476 18.098 20.4313 18.621 19.3316 18.8629C18.3175 19.0853 17.1983 19.0193 16.1989 18.7603C15.1481 18.4866 14.1315 18.0296 13.0514 17.5433C11.9029 17.0277 10.7178 16.4926 9.43242 16.1651C8.82151 16.0087 8.18127 15.933 7.5337 15.933C6.65154 15.933 5.75472 16.0771 4.90189 16.3606C4.15657 16.6099 3.46502 16.9568 2.84433 17.3943C2.18943 17.8561 1.62984 18.406 1.18021 19.0315C1.15088 19.0731 1.12645 19.1146 1.10445 19.1586C0.891854 19.5814 1.00915 20.1116 1.40747 20.3975Z" />
      <path d="M19.1042 14.8621C21.0085 14.8621 22.5522 13.3184 22.5522 11.4141C22.5522 9.50985 21.0085 7.96613 19.1042 7.96613C17.2 7.96613 15.6562 9.50985 15.6562 11.4141C15.6562 13.3184 17.2 14.8621 19.1042 14.8621Z" />
    </svg>
  );
};
/* eslint-enable max-len */
Swim.defaultProps = {
  className: null,
};

Swim.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Swim;
